import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useTheme } from '@bcp-nextgen-dx-component-factory/design-system';

interface WaitingForCallHelperResources {
	title: string;
	subtitle: string;
}

interface WaitingForCallHelperOutput {
	cerise: string;
	resources: WaitingForCallHelperResources;
}

export const useWaitingForCallHelper = (): WaitingForCallHelperOutput => {
	const t = useTranslation();
	const { colorPalette } = useTheme();

	const cerise = colorPalette.color_02[100];

	const resources: WaitingForCallHelperResources = {
		title: t('modals.waitingForCall.title'),
		subtitle: t('modals.waitingForCall.subtitle'),
	};

	return { cerise, resources };
};
